import axios from "axios";
import AuthService from "@/services/AuthService";

const instance = axios.create({
  baseURL: process.env.VUE_APP_CAMPAIGNS_API_URL,
});
const isProd = JSON.parse(process.env.VUE_APP_IS_PRODUCTION);
export default {

  async getCampaigns(query) {
    // console.log("query",query);

    try {
      // console.log("campain start controller")
      const response = await instance.get("campaigns" + query, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      // console.log("campain end controller",response)
      return response;
    } catch (error) {
      alert("Something went wrong");
      return error.response;
    }
  },

  async getCampaignsCount(query) {
    try {

      const response = await instance.get("campaignsCounts"+ query, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      alert("Something went wrong");
      return error.response;
    }
  },

  async fetchCampaignAudience(id) {
    try {
      const response = await instance.get("camapignAudience?id=" + id, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async fetchMestaCampaignAudienceCount({
    campaignId="",
    levels=[],
    grades=[],
    assessmentName=[],
  }){
    try {
      
      const response = await instance.get( `getMestaCampaignAudienceCount?campaignId=${campaignId}&level=${levels}&grade=${grades}&assesmentName=${assessmentName}`,{
        headers: {
            'Authorization': AuthService.getToken()
        }
      })
      return response;
    }
    catch(error){
      alert("Something went wrong");
      return error.response;
    }
  },
  async fetchMestaCampaignAudience({
    campaignId="",
    itemsPerPage="10",
    page="1",
    latestStatus="",
    search="",
    levels=[],
    grades=[],
    assessmentName=[],
    sortOrder = 'desc'
  }){
    try {
      
      const response = await instance.get( `getMestaCampaignAudience?campaignId=${campaignId}&itemsPerPage=${itemsPerPage}&page=${page}&latestStatus=${latestStatus}&search=${search}&level=${levels}&grades=${grades}&assesmentName=${assessmentName}&sortOrder=${sortOrder}`,{
        headers: {
            'Authorization': AuthService.getToken()
        }
      })
      return response;
    }
    catch(error){
      alert("Something went wrong");
      return error.response;
    }
  },
  async demoTopicsConfigration(id, demoConfigration) {
    try {
      const response = await instance.put("campaignDemoConfigration?id=" + id, {
        demoConfigration: demoConfigration
      }, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },

  updateCampaignDates: async function ({
    screeningEndDate = "",
    mainsEndDate = "",
    endDate = "",
    campaignId  = ""
  }) {
    try {
      const response = await instance.put(
        "/updateCampaignDates",
        { screeningEndDate, mainsEndDate, endDate, campaignId },
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },

  createCampaign: async function (data) {
    try {
      const response = await instance.post("campaign", data, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },

  createCampaignConfigration: async function (campaignConfigration, id) {
    // console.log("id", id)
    try {
      const response = await instance.put(
        "campaignConfigration?id=" + id,
        { campaignConfigration },
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },
  createCampaignAudiance: async function (audiance, id, isAudianceAdded) {
    try {
      const response = await instance.put(
        "campaignAudiance?id=" + id,
        { audiance, isAudianceAdded },
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async getResult(userId, campaignId) {
    try {
      const response = await instance.get(
        "getResult?userId=" + userId + "&campaignId=" + campaignId,
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async deleteCampaign(id) {
    try {
      const response = await instance.delete("deleteCampaign?id=" + id, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },

  async filterCampaign(query,schools, clusters, levels, skills) {
    try {
      const response = await instance.put(
        "filterCampaigns"+query,
        { schools, clusters, levels, skills },
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async filterCampaignUser(clusters, boards, id) {
    try {
      const response = await instance.put(
        "filterCamapignAudience",
        { clusters, boards, id },
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },

  async getReportData(userId, camapignId) {
    try {
      const response = await instance.get(
        "getUserResult?userId=" + userId + "&campaignId=" + camapignId,
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async getAvalableSlots(schoolCode) {
    try {
      const response = await instance.get('/getInterviewSlots?schoolCode=' + schoolCode, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async getSlotApprovalRequests(query = "") {
    try {
      const response = await instance.get('slotApprovalRequests' + query, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async getRejectedSlots(query = "") {
    try {
      const response = await instance.get('rejectedSlots' + query, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async requestSlotApproval(data) {
    try {
      const response = await instance.post('/requestSlotApproval', data, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async respondSlotApproval(data) {
    try {
      const response = await instance.post('/respondSlotApproval', data, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async deleteInterviewerFromSlot(data) {
    try {
      const response = await instance.post('/deleteInterviewerFromSlot', data, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async submitInterviewFinalStatus(body) {
    try {
      const response = await instance.post('/submitInterviewFinalStatus', body, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async getIntervieweeList(queryString) {
    try {
      const response = await instance.get('/intervieweeList' + queryString, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async downloadIntervieweeList(queryString) {
    try {
      const response = await instance.get('/intervieweeList/download' + queryString, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async checkAvalableSlotsForInterviewer(email, slotId, slotIndex, isApprovalRequired) {
    try {
      const response = await instance.post('/slotAvalable', {
        email: email,
        slotId: slotId,
        slotIndex: slotIndex,
        isApprovalRequired
      }, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
    async fetchInterviewerHistory(query  ) {
    try {
      const response = await instance.get('getInterviewerHistory'+ query, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
   async fetchInterviewerHistoryV2(query  ) {
    try {
      const response = await instance.get('getCandidateInterviewHistory'+ query, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
    async acceptOrRejectbyInterviewer(data) {
    try {
      const response = await instance.post('/webhooks/calendar-rsvp', data, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async setNewFeedbackFlag(data) {
    try {
      const response = await instance.post('/setNewFeedbackFlag', data, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.result;
    }
  },
  async submitInterviewScheduleDetails(data) {
    try {
      const response = await instance.post('/bookInterviewSlot', data, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
    async delegateInterviewSlot(data) {
    try {
      const response = await instance.post('/delegateInterviewSlot', data, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async getInterViewUserInfo(emailId, slotId, timeSlotId, userId, campaignId) {
    console.log('emailId', emailId)
    console.log('slotId', slotId)
    console.log('timeSlotId', timeSlotId)
    console.log('userId', userId)

    try {
      const response = await instance.get(
        "scheduledInterview/" + emailId + "/bookedSlots/" + slotId + "/timeSlot/" + timeSlotId + "/userId/" + userId + "/campaignId/" + campaignId,
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async retriveInterViewFeedback(query) {
    try {
      const response = await instance.get(
        "interveiwFeedbackInprogress" + query,
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response
      // return response;
    } catch (error) {
      return error.response;
    }
  },
  async intervieweeStatusCount(query) {
    try {
      const response = await instance.get(
        "intervieweeStatusCount" + query,
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response
      // return response;
    } catch (error) {
      return error.response;
    }
  },
    async getAssignedInterviewerStatus(data) {
    try {
      const response = await instance.post('getInterviewInviteResponse',
        data,
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async autoSaveInterviewFeedback(data) {
    try {
      const response = await instance.post('autoSaveInterviewFeedback',
        data,
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async submitInterViewFeedback(emailId, slotId, timeSlotId, data, userId, campaignId, currentTestRoundIndex) {
    try {
      const response = await instance.post(
        "scheduledInterview/" + emailId + "/bookedSlots/" + slotId + "/timeSlot/" + timeSlotId + "/userId/" + userId + "/campaignId/" + campaignId + "/currentTestRoundIndex/" + currentTestRoundIndex,
        data,
        {
          headers: {
            Authorization: AuthService.getToken(),
          },
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async getInterviewReport(userId, campaignId) {
    try {
      const response = await instance.get("getInterviewFeedback", {
        headers: {
          Authorization: AuthService.getToken(),
        },
        params: {
          userId,
          campaignId
        }
      });
      return response;
    } catch (error) {
      alert("Something went wrong");
      return error.response;
    }
  },
  async inviteUsersToCampaign(campaignId, audiance) {
    try {
      const response = await instance.put(`campaignAudiance?id=${campaignId}`, {
        audiance
      }, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  async resetInterviewNotificationBadge(payload) {
    try {
      const response = await instance.put(`resetInterviewNotificationBadge`,payload, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  async getCampaign(query) {
    console.log('getCampaign')
    try {
      // console.log("campain start controller")
      const response = await instance.get("campaign" + query, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      // console.log("campain end controller",response)
      return response;
    } catch (error) {
      alert("Something went wrong");
      return error.response;
    }
  },

  async clearUserAssessment(userId, campaignId, email) {
    try {
      const response = await instance.put(`clearUserAssessment`, {
        userId, campaignId, sendInvite: true, email,
      }, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  async getEligibleTeachers(id, limit, offset) {
    console.log('getEligibleTeachers for id : ', id)
    try {
      const response = await instance.get("eligibleTeachers?campaignId=" + id, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      console.log("getEligibleTeachers end controller",response)
      return response;
    } catch (error) {
      return error;
    }
  },

  async getTopTeachers(limit) {
    try {
    console.log("limit:"+ limit);
    const response = await instance.get("getTopTeachers/"+ limit);
    return response.data;
    } catch (error) {
      return error.response;
    }
  },

  async getCampaignAudience(query="",body={}, signal) {
    try{
      // let path = isProd ? 'getCampaignAudienceFromAlgolia' : 'getCampaignAudience';
      let path = 'getCampaignAudience';
      const response = await instance.put(path+query,{
        ...body
      }, {signal});
      return response.data;
    } catch (error) {
      return error.response;
    }
  },
  async getAudienceStatusCounts(query="",body={}, signal){
    try{
      const response = await instance.put('getAudienceStatusCounts' + query, { ...body }, {signal});
      return response.data;
    } catch (error) {
      return error.response;
    }
  },
  async downloadCampaignAudience(body = {}) {
  try {
    console.log('body', body);

    const response = await instance.post('downloadCampaignAudience', body, {
      responseType: 'blob', // <-- important to get binary/blob response
    });

    return response;
  } catch (error) {
    // you might want to throw or return something meaningful here
    throw error;
  }
},
  async getMestaCampaigns() {
    try {
      const response = await instance.get("getMestaCampaigns", {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response.data;
    } catch (error) {
      return error.response;
    }
  },
  async getPerformanceReport(userId, campaignId, testType){
    try{
      const response =  await instance.get(`getPerformanceReport?userId=${userId}&campaignId=${campaignId}&testType=${testType}`);
      return response.data;
    }
    catch(error){
      return error
    }
  },

  async fetchCandidates(adminId,sortCol,sortOrder) {
    try {
      const response = await instance.get(`getCandidateListing?adminId=${adminId}&sortCol=${sortCol}&sortOrder=${sortOrder}`);
      return response;
    } catch (error) {
      console.error('Error fetching candidates:', error);
    }
  },
  async hiringManagerAvailability({ campaignId, userId, round, level, hmEmail, response }) {
    try {
      const query =
        `?campaignId=${encodeURIComponent(campaignId)}` +
        `&userId=${encodeURIComponent(userId)}` +
        `&round=${encodeURIComponent(round)}` +
        `&level=${encodeURIComponent(level)}` +
        `&hmEmail=${encodeURIComponent(hmEmail)}` +
        `&response=${encodeURIComponent(response)}`;
      const res = await instance.get('hiringManagerAvailability' + query, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return res;
    } catch (error) {
      console.error('Error confirming hiring manager availability:', error);
      return error.response;
    }
  },
  fetchQuestionNonAdaptiveTest: async function (userId, campaignId) {
    try {
      const response = await instance.post("/fetchQuestionNonAdaptiveTest", {
        userId: userId,
        campaignId: campaignId,
      }, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      console.log('response',response)
      return response;
    } catch (error) {
      return error.response;
    }
  },
  generateDemoTopics: async function (userId, campaignId, subjects, levels, userType, applyPassedSubjectFilter, passedSubjects, sendMail) {
    try {
      const response = await instance.post("/generateDemoTopics", {
        userId: userId,
        campaignId: campaignId,
        subjects: subjects,
        levels: [levels],
        userType: userType,
        applyPassedSubjectFilter: applyPassedSubjectFilter,
        passedSubjects: passedSubjects,
        sendMail
      }, {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      console.log('response',response)
      return response;
    } catch (error) {
      return error.response;
    }
  },
  getCampaignFilters: async function (campaignId) {
  try {
    const response = await instance.get(`get-campaign-filters/${campaignId}`);
    return response.data;
  } catch (error) {
    return error.response;
  }

  },
  getMasterFilters: async function (docId) {
    try {
      const response = await instance.get(`get-master-filters/${docId}`);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },
  async generateTestReport({htmlContent, campaignId, targetUserId, assessmentType, reportType, testType}){
      try{
        const response = await instance.post('/generate-test-report', 
          { htmlContent, campaignId, targetUserId, assessmentType, reportType, testType }
        )
        return response.data;
      }
      catch(error){
        console.error('Error in report Generation:',error);
        return error.response
      }
  },

  getCampaignMetaData: async function(campaignId){
    try {
      const response = await instance.get(`fetchCampaignMetaData?campaignId=${campaignId}`);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },
  async fetchCampaigns() {
    try {
      const response = await instance.get("fetchCampaigns", {
        headers: {
          Authorization: AuthService.getToken(),
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },
  async sendAssessmentReminders(campaignId, users, reminderTriggeredBy){
    try{
      const response =  await instance.post("send-assessment-reminders", 
        { campaignId, users, reminderTriggeredBy },
        { headers: {Authorization: AuthService.getToken(),},}
      );

      return response.data;
    }
    catch(error){
      console.error('Error sending email reminders')
      return;
    }
  },
  getMasterFiltersForIntervieweeList: async function (docId) {
    try {
      const response = await instance.get(`getInterviewFilters?interviewerEmail=${docId}`);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },
  async downloadInterviewAttendanceReport(params) {
    const response = await instance.get("interviewAttendanceReport", {
      params,
      responseType: "blob",
    });
    return response;
  },

};